// The conversations list request: filters, paging and order (see getProjectChats).
export interface ChatsRequest {
  project_id: string | null;
  service: string;
  // Dates are empty strings when not filtered.
  created_at_start: string;
  created_at_end: string;
  updated_at_start: string;
  updated_at_end: string;
  page: number;
  page_size: number;
  chat_status: string[];
  // Narrows escalated conversations by why they escalated; empty means any reason.
  escalation_reason_category: string[];
  account: string;
  types: string[];
  order_by: string[];
}

// The filter and chips report only the fields they change.
export type ChatsRequestChange = Partial<ChatsRequest>;

// Why a conversation escalated: the escalation_reason_category values and their labels.
export const ESCALATION_REASONS = [
  { value: 'knowledge_gap', label: 'Knowledge gap' },
  { value: 'user_request', label: 'Customer request' },
  { value: 'model_configuration', label: 'Workflow rule' },
  { value: 'other', label: 'Other' },
];
